import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  convertirPeriodoEnBuscador,
  convertirPeriodoEnValue,
} from "../../../../utils/Tools";
import agencia from '../../../../imagenes/logo/agencia-ic.png'

const BuscadorPorOrigen = (props) => {
  const {
    busqueda,
    solosYsolas,
    onSelectOrigenChange,
    onSelectDestinoChange,
    onSelectPeriodoChange,
    onSelectEmbarqueBusquedaChange,
    onSelectTipoBusquedaChange,
    onSelectChange,
    onAdultosChange,
    onMenoresChange,
    onEdadChange,
    estilos,
    grupo,
  } = props;

  const [error, setError] = useState(false);
  const [errorPeriodo, setErrorPeriodo] = useState(false);

  const [errores, setErrores] = useState({
    destino: false,
    fecha: false,
    origen: false,
    puntoDeEmbarque: false,
  });
  /*const [provinciaElegida, setProvinciaElegida] = useState({
    codigo: "",
    puntosDeEmbarque: [],
  });
*/
  // Helper para dibujar las opciones del select de adultos
  const dibujarOptionAdultos = (cantidad) => {
    let options = [];
    if (solosYsolas) {
      options.push(
        <option key="0" value="1">
          1
        </option>
      );
    } else {
      // Lógica general
      for (let i = 1; i <= cantidad; i++) {
        options.push(
          <option key={i} value={i}>
            {i}
          </option>
        );
      }
    }
    return options;
  };

  // Helper para dibujar las opciones del select de menores
  const dibujarOptionMenores = (cantidad) => {
    let options = [];
    if (!solosYsolas) {
      for (let i = 0; i <= cantidad; i++) {
        options.push(
          <option key={i} value={i}>
            {i}
          </option>
        );
      }
    }
    return options;
  };

  // Manejadores de eventos para los cambios en los selectores
  const handleCombosOrigenBusquedaChange = (ev) => {
    const provElegida = busqueda.provincias.find(
      (e) => e.codigo === ev.target.value
    );
    //setProvinciaElegida(provElegida);
    onSelectOrigenChange(provElegida);
  };

  const handleCombosDestinoBusquedaChange = (e) => {
    onSelectDestinoChange(e.target.value, "porOrigen");
  };

  const handleComboPeriodoBusquedaChange = (e) => {
    onSelectPeriodoChange(
      e.target.value,
      busqueda.destino,
      busqueda.provinciaElegida.codigo,
      busqueda.puntoDeEmbarque.idPuntoDeEmbarque,
      "porOrigen"
    );
  };

  const handleCombosEmbarqueBusquedaChange = (e) => {
    const idEmbarque = e.target.value;
    /*
    const embarqueSeleccionado =
      busqueda.provinciaElegida.puntosDeEmbarque.find(
        (e) => e.idPuntoDeEmbarque === idEmbarque
      );
      */
    const embarqueSeleccionado =
      busqueda.embarques.find(
        (e) => e.idPuntoDeEmbarque === idEmbarque
      );
    onSelectEmbarqueBusquedaChange(embarqueSeleccionado, "porOrigen");
  };

  const handleCombosBusquedaChange = (e) => {
    onSelectChange(e.target.name, e.target.value);
  };

  const handleAdultosChange = (e) => {
    onAdultosChange(e.target.value);
  };

  const handleMenoresChange = (e) => {
    onMenoresChange(e.target.value);
  };

  const handleEdadChange = (e) => {
    onEdadChange(e.target.id, e.target.value);
  };

  const prepareURL = () => {
    let url = `/paquetes-turisticos/${busqueda.provinciaElegida.codigo}/${busqueda.puntoDeEmbarque.idPuntoDeEmbarque}/${busqueda.origen}/${busqueda.destino}/${busqueda.fecha}/`;
    if (grupo) {
      url = `/paquetes-turisticos/${busqueda.provinciaElegida.codigo}/${
        busqueda.puntoDeEmbarque.idPuntoDeEmbarque
      }/${busqueda.origen}/${busqueda.destino}/${busqueda.fecha}/0/${
        grupo.idGrupo
      }/${encodeURI(grupo.descripcion)}`;
    }
    return url;
  };

  // Manejador del envío del formulario
  const handleSubmit = (evt) => {
    if (
      busqueda.destino === "" ||
      busqueda.fecha === "" ||
      busqueda.fecha === "0" ||
      busqueda.provinciaElegida.codigo === "" ||
      busqueda.puntoDeEmbarque.idPuntoDeEmbarque === 0 ||
      !busqueda.puntoDeEmbarque.idPuntoDeEmbarque
    ) {
      setErrores({
        destino: busqueda.destino === "",
        fecha: busqueda.fecha === "" || busqueda.fecha === "0",
        origen: busqueda.provinciaElegida.codigo === "",
        puntoDeEmbarque:
          busqueda.puntoDeEmbarque.idPuntoDeEmbarque === 0 ||
          !busqueda.puntoDeEmbarque.idPuntoDeEmbarque,
      });
      //setError(true); // Establece el error de destino
      //setErrorPeriodo(false); // Resetea el error de período
      evt.preventDefault();
      return;
    } else {
      setErrores({
        destino: false,
        fecha: false,
        origen: false,
        puntoDeEmbarque: false,
      });
    }

    /*
    if (busqueda.destino === "") {
      setError(true); // Establece el error de destino
      setErrorPeriodo(false); // Resetea el error de período
      evt.preventDefault();
      return;
    }

    if (busqueda.fecha === "" || busqueda.fecha === "0") {
      setErrorPeriodo(true); // Establece el error de período
      setError(false); // Resetea el error de destino
      evt.preventDefault();
      return;
    }
    */

    // Si no hay errores, el Link a la ruta funcionará normalmente.
    // No se necesita `evt.preventDefault()` aquí si la validación es exitosa,
    // ya que el `Link` de `react-router-dom` maneja la navegación.
  };

  return (
    <form action="#" method="POST">
      <div className="buscadorRadioButton">
        <p style={{color: "#fff"}}>Buscá los mejores Paquetes:
        <span>
          <input
            id="porDestino"
            className="radioPuntoEmbarque"
            type="radio"
            name="tipoBusqueda"
            onChange={(e) => onSelectTipoBusquedaChange("porDestino")}
            value={busqueda.tipoBusqueda === "porDestino"}
            checked={busqueda.tipoBusqueda === "porDestino"}
            disabled={solosYsolas ? "disabled" : null}
          />
          <label htmlFor="porDestino" style={{margin: "0 2px"}}>Por Destino</label>
        </span>
        {/* <img alt="Buscar Agencias" title="Buscar agencias" src={agencia}   />  */}
        <input
          id="porOrigen"
          className="radioPuntoEmbarque"
          type="radio"
          name="tipoBusqueda"
          onChange={(e) => onSelectTipoBusquedaChange("porOrigen")}
          value={busqueda.tipoBusqueda === "porOrigen"}
          checked={busqueda.tipoBusqueda === "porOrigen"}
          disabled={solosYsolas ? "disabled" : null}
        />   
        <label htmlFor="porOrigen">Por Origen</label>  
        </p>
      </div>
      <div className={estilos.estilo1 + " notranslate"}>

{/*         <div className={estilos.estilosInputs + " input-container"}>
          <label htmlFor="provinciaElegida">Origen</label>{" "}
          {errores.origen && (
            <span className="formError">Debe seleccionar un origen</span>
          )}
          <select
            name="codigoProvincia"
            value={busqueda.provinciaElegida.codigo}
            onChange={handleCombosOrigenBusquedaChange}
            placeholder="Seleccione donde salir"
          >
            <option value="">Seleccione origen</option>
            {busqueda.provincias.map((prov, index) => (
              <option key={index} value={prov.codigo}>
                {prov.denominacion}
              </option>
            ))}
          </select>
        </div> */}

        <div className={estilos.estilosInputsPorOrigen + " input-container"}>
          <label htmlFor="origen">Seleccione desde</label>{" "}
          {errores.puntoDeEmbarque && (
            <span className="formError">Debe seleccionar un embarque</span>
          )}
          <select
            name="puntoDeEmbarque"
            value={busqueda.puntoDeEmbarque.idPuntoDeEmbarque}
            onChange={handleCombosEmbarqueBusquedaChange}
            disabled={solosYsolas ? "disabled" : null}
            placeholder="Seleccione la parada"
          >
            <option value="">Seleccione Salida</option>
            {/*busqueda.provinciaElegida.puntosDeEmbarque &&
              busqueda.provinciaElegida.puntosDeEmbarque.map(
                (embarque, index) => (
                  <option key={index} value={embarque.idPuntoDeEmbarque}>
                    {embarque.denominacion}
                  </option>
                )
              )
                */}
            {busqueda.embarques.map(
                (embarque, index) => (
                  <option key={index} value={embarque.idPuntoDeEmbarque}>
                    {embarque.denominacion}
                  </option>
                )
              )}
          </select>
        </div>

        <div className={estilos.estilosDestinos + " input-container"}>
          <label htmlFor="destino">Destino </label>{" "}
          {errores.destino && (
            <span className="formError">Debe seleccionar un destino</span>
          )}
          <select
            name="destino"
            value={busqueda.destino}
            disabled={solosYsolas ? "disabled" : null}
            onChange={handleCombosDestinoBusquedaChange}
            placeholder="Ingrese hacia dónde viaja"
          >
            <option value="">Buscar Destino</option>
            {busqueda.destinos.map((destino) => (
              <option key={destino.idDestino} value={destino.idDestino}>
                {destino.descripcion}
              </option>
            ))}
          </select>
        </div>

        <div className={estilos.estilosInputFecha + " input-container"}>
          <label htmlFor="periodo">Período de viaje</label>{" "}
          {errores.fecha && (
            <span className="formError">Debe seleccionar un periodo</span>
          )}
          <select
            name="fecha"
            value={busqueda.fecha}
            disabled={solosYsolas ? "disabled" : null}
            onChange={handleComboPeriodoBusquedaChange}
            className="small"
          >
            {busqueda.periodos.length === 0 ? (
              <option value="0">Elegir Periodo</option>
            ) : (
              <option value="0">Elegir Periodo</option>
            )}
            {busqueda.periodos.map((periodo, index) => (
              <option key={index} value={convertirPeriodoEnValue(periodo)}>
                {convertirPeriodoEnBuscador(periodo)}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className={estilos.estilo1}>
        <div
          className={
            estilos.estilosAdultosMenores +
            " input-container"
          }
        >
          <div className="habitaciones">
            <div className="row">
              <div className={estilos.estiloInputEdadMenor}>
                <label htmlFor="adultos">Adultos (+2 años)</label>
                <select
                  name="adultos"
                  value={busqueda.adultos}
                  onChange={handleAdultosChange}
                >
                  {dibujarOptionAdultos(6)}
                </select>
              </div>
              <div className={estilos.estiloInputEdadMenor}>
                <label htmlFor="menores">Menores de 2 años</label>
                <select
                  name="menores"
                  value={props.busqueda.menores.length}
                  disabled={solosYsolas ? "disabled" : null}
                  onChange={handleMenoresChange}
                >
                  {dibujarOptionMenores(6)}
                </select>
              </div>
              {busqueda.menores.map((value, key) => (
                <div key={key} className={estilos.estiloInputEdadMenor}>
                  <label>Edad</label>
                  <select id={key} value={value} onChange={handleEdadChange}>
                    {dibujarOptionMenores(1)}
                  </select>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={estilos.estiloBoton}>
          <Link to={prepareURL} onClick={handleSubmit}>
            <input
              type="submit"
              disabled={solosYsolas ? "disabled" : !busqueda.estadoBoton}
              value="Buscar"
            />
          </Link>
        </div>
      </div>
    </form>
  );
};

export default BuscadorPorOrigen;



// WEBPACK FOOTER //
// ./src/components/Home/SeccionBuscador/BuscadorPorOrigen/index.js